var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.location && _vm.room && _vm.online !== null
    ? _c("SoliAvatarBtn", {
        attrs: {
          title: `${_vm.location.name} | ${
            _vm.online ? "Online" : _vm.room.title
          }`,
          icon: "storefront",
          subtitleBottom: _vm.online ? null : _vm.addressLineOne,
          subtitleBottom2: _vm.addressLineTwo,
          blue: "",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("input", _vm.location)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }